module.exports = __webpack_public_path__ + "img/features_18.9d745676.png";